import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class RefreshIcon extends BaseIcon {
  getChildren = () => [ <path fill={ this.getColor() }
                              fillRule='evenodd'
                              d='M16.000,5.000 L12.602,9.221 L9.000,5.000 L11.534,5.000 C10.761,3.247 9.037,2.010 6.998,2.010 C4.241,2.010 2.006,4.246 2.006,7.005 C2.006,9.763 4.241,11.999 6.998,11.999 C7.850,11.999 8.640,11.766 9.342,11.389 L10.703,12.940 C9.627,13.614 8.360,14.009 6.997,14.009 C3.132,14.009 -0.002,10.874 -0.002,7.007 C-0.002,3.139 3.132,0.004 6.997,0.004 C10.163,0.004 12.820,2.114 13.683,5.000 L16.000,5.000 Z'
                              transform='translate(0 1)'/> ]
  getViewBox = () => '0 0 16 16'
}
